module.exports = __webpack_public_path__ + "img/dmkfcd.008d6f9d.jpg";